/** First visit only: supported browser preferences, then a regional timezone fallback. */
export function detectInitialLocale(languages: readonly string[], timeZone: string): 'en' | 'fa' | 'ar' | 'tr' {
  for (const language of languages) {
    const code = language.toLowerCase().split(/[-_]/)[0];
    if (code === 'fa' || code === 'ar' || code === 'tr' || code === 'en') return code;
  }
  if (timeZone === 'Asia/Tehran') return 'fa';
  if (timeZone === 'Europe/Istanbul') return 'tr';
  if (['Asia/Riyadh','Asia/Dubai','Asia/Baghdad','Asia/Qatar','Asia/Kuwait','Asia/Bahrain','Asia/Muscat','Asia/Amman','Asia/Beirut','Asia/Damascus','Africa/Cairo','Africa/Algiers','Africa/Tunis','Africa/Tripoli','Africa/Khartoum','Africa/Casablanca'].includes(timeZone)) return 'ar';
  return 'en';
}
export function browserInitialLocale() {
  let zone = '';
  try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { /* Browser language remains available. */ }
  return detectInitialLocale(typeof navigator === 'undefined' ? [] : navigator.languages ?? [navigator.language], zone);
}
